/* eslint-disable camelcase */
import momentTz from 'moment-timezone'
import { isInt } from '../utils/utils'

const getQueryToApiParams = isTranslationsTraffic => {
  return {
    sport: 'sport_id',
    country: `${isTranslationsTraffic ? '' : 'tournament.'}country_id`,
    tournamentCountry: `${isTranslationsTraffic ? '' : 'tournament.'}event_country_id`,
    gender: `${isTranslationsTraffic ? '' : 'tournament.'}gender_id`,
    age: `${isTranslationsTraffic ? '' : 'tournament.'}age_id`,
    tournament: 'tournament_id',
    bookType: 'ability_id',
    state: 'state_id',
    booked: 'booked'
  }
}

const addComposedBookParam = (data) => {
  const filters = data
  const { booked, ability_id } = filters

  if (!booked || !ability_id) {
    return filters
  }

  switch (ability_id) {
    case 'gamedata-translation':
      filters['booked_all'] = 'd'

      break
    case 'video-translation':
      filters['booked_all'] = 'v'

      break
    case 'liver-translation':
      filters['booked_all'] = 't'

      break
    case 'market-translation':
      filters['booked_all'] = 'm'

      break
  }

  return filters
}
const addSearchParam = (data, searchParam) => {
  const params = data

  if (isInt(searchParam)) {
    params.filter = {
      self_id: searchParam
    }

    return params
  }

  params.search = { value: searchParam }

  return params
}
const getApiParameter = (key, query, isTranslationTraffic) => {
  if (
    query.hasOwnProperty(key) &&
    getQueryToApiParams(isTranslationTraffic).hasOwnProperty(key)
  ) {
    return getQueryToApiParams(isTranslationTraffic)[key]
  }

  return false
}
const addCommonParams = (data, query, isTranslationTraffic) => {
  const queryKeys = Object.keys(query)
  const params = data

  params.filter = {}

  queryKeys.forEach(key => {
    const param = getApiParameter(key, query, isTranslationTraffic)

    if (param) {
      params.filter[param] = query[key]
    }
  })

  return params
}
const addTimeParams = (data, { time, from, to }, isTranslationTraffic) => {
  const fromLabel = isTranslationTraffic ? 'traffic_from' : 'start_at_from'
  const toLabel = isTranslationTraffic ? 'traffic_to' : 'start_at_to'
  const params = data

  switch (time) {
    case 'today':
      params.filter[fromLabel] = momentTz().startOf('day').format('YYYY-MM-DDTHH:mm:ss')
      params.filter[toLabel] = momentTz().endOf('day').format('YYYY-MM-DDTHH:mm:ss')

      break

    case 'tomorrow':
      params.filter[fromLabel] = momentTz().add(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss')
      params.filter[toLabel] = momentTz().add(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss')

      break

    case 'nextWeek':
      params.filter[fromLabel] = momentTz().startOf('week').format('YYYY-MM-DDTHH:mm:ss')
      params.filter[toLabel] = momentTz().endOf('week').format('YYYY-MM-DDTHH:mm:ss')

      break

    case 'nextMonth':
      params.filter[fromLabel] = momentTz().startOf('month').format('YYYY-MM-DDTHH:mm:ss')
      params.filter[toLabel] = momentTz().endOf('month').format('YYYY-MM-DDTHH:mm:ss')

      break

    case 'dateRange':
      if (from) {
        params.filter[fromLabel] = `${from}T00:00:00`
      }
      if (to) {
        params.filter[toLabel] = `${to}T23:59:59`
      }

      break
  }

  return params
}

export default {
  methods: {
    createTranslationsParams (query, commonTranslation = true) {
      const isTranslationTraffic = this.$route.name === 'reports.translationstraffic'
      const search = query['search']
      const time = {
        time: commonTranslation ? query['time'] : 'dateRange',
        from: query['from'],
        to: query['to']
      }

      let resultParams = {}

      resultParams = addSearchParam(resultParams, search)

      if (!isInt(search)) {
        resultParams = addCommonParams(resultParams, query, isTranslationTraffic)

        resultParams = addTimeParams(resultParams, time, isTranslationTraffic)

        resultParams.filter = addComposedBookParam(resultParams.filter)
      }

      if (!isTranslationTraffic) {
        resultParams.with_attributes = ['booking', 'additional_titles']
      }

      if (Number(resultParams.filter.state_id) === 2) {
        resultParams.filter.state_id = 1

        resultParams.with_attributes = resultParams.with_attributes ? [
          ...resultParams.with_attributes,
          ...['postponed']
        ] : ['postponed']
      }

      return resultParams
    }
  }
}
